export default {
    specialAuthorizations: { edit: { groups: [] } }
};
